import * as types from './meeting-templates.types';
import * as constants from './meeting-templates.constants';
import { IMeetingTemplate } from '../../../resource/meeting-templates/meeting-templates.types';

export const fetchMeetingTemplates = (): types.IFetchMeetingTemplates => ({
  type: constants.FETCH_MEETING_TEMPLATES,
});

export const storeMeetingTemplateIds = (
  meetingsSimpleIds: IMeetingTemplate['id'][],
): types.IStoreMeetingTemplatesIds => ({
  type: constants.STORE_MEETING_TEMPLATES_IDS,
  payload: meetingsSimpleIds,
});
export const clearMeetingTemplateIds = (): types.IClearMeetingTemplatesIds => ({
  type: constants.CLEAR_MEETING_TEMPLATES_IDS,
});
